__turbopack_context__.v({
  "btn": "button-module__HjQxJG__btn",
});
